import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button } from '@chakra-ui/react'
import type { MouseEvent, Ref } from 'react'
import { memo } from 'react'

interface IAlertSubmitButtonProps {
  text?: string
  onClick?: (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => void
  customElement?: React.ReactNode
  ref?: Ref<HTMLButtonElement>
}

interface CustomConfirmDialogProps {
  isOpen: boolean
  onClose: () => void
  title?: string | React.ReactNode
  children: string | React.ReactNode
  yesButton: IAlertSubmitButtonProps,
  noButton: IAlertSubmitButtonProps,
  leastDestructiveRef?: any
}

export const CustomConfirmDialog = memo(({
  isOpen,
  onClose,
  title,
  children,
  yesButton,
  noButton,
  leastDestructiveRef
}: CustomConfirmDialogProps) => {

  return (
    <AlertDialog
      leastDestructiveRef={leastDestructiveRef}
      isOpen={isOpen}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          {title &&
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              {title}
            </AlertDialogHeader>
          }

          {children &&
            <AlertDialogBody>
              {children}
            </AlertDialogBody>
          }

          <AlertDialogFooter>
            {noButton.customElement && noButton.customElement}
            {!noButton.customElement &&
              <Button
                variant="solid"
                colorScheme="gray"
                onClick={noButton.onClick}
                ref={noButton.ref}
              >
                {noButton.text && noButton.text}
                {!noButton.text && 'Ne'}
              </Button>
            }

            {yesButton.customElement && yesButton.customElement}
            {!yesButton.customElement &&
              <Button
                variant="solid"
                colorScheme="green"
                color='white'
                onClick={yesButton.onClick}
                ml={3}
                ref={yesButton.ref}
              >
                {yesButton.text && yesButton.text}
                {!yesButton.text && 'Ano'}
              </Button>
            }

          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}) 